module.exports = __webpack_public_path__ + "static/banner_image-fd303b3605f3946ebbba82dfb0c8412b.png";